var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_box"},[_c('img',{staticClass:"loading",attrs:{"slot":"loading","src":_vm.loadingSrc,"rel":"external nofollow"},slot:"loading"})])}
var staticRenderFns = []

export { render, staticRenderFns }